import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingHotline from "@/components/FloatingHotline";
import InstallPrompt from "@/components/InstallPrompt";

export default function MainLayout() {
  const loc = useLocation();
  const isHome = loc.pathname === "/";
  return (
    <div className="min-h-screen bg-black text-white relative">
      <Header />
      <main className={isHome ? "relative z-10" : "pt-20 relative z-10"}>
        <Outlet />
      </main>
      <Footer />
      <FloatingHotline />
      <InstallPrompt />
    </div>
  );
}
